import { toSelection } from './billing.js';
import { request } from './client.js';
import { toQuery } from '../utils/params.js';

export const pushQueueApi = {
  // Takes ticked ids or a whole filter — see toSelection in ./billing.js.
  pushRecords: (selection) =>
    request('/api/billing/records/push', {
      method: 'POST',
      body: JSON.stringify(toSelection(selection)),
    }),
  list: (params = {}) => {
    // Back-compat: callers passing a single string still work as a status filter.
    const p = typeof params === 'string' ? { status: params } : params;
    return request(`/api/billing/push-queue${toQuery(p)}`);
  },
  retry: (queueId) =>
    request('/api/billing/push-queue/retry', {
      method: 'POST',
      body: JSON.stringify(queueId ? { queue_id: queueId } : {}),
    }),
  voidTimeBill: (queueId) =>
    request('/api/billing/push-queue/void', {
      method: 'POST',
      body: JSON.stringify({ queue_id: queueId }),
    }),
};
